import React from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxArchive, faCameraRetro } from "@fortawesome/free-solid-svg-icons";

// Flag temporária: a equipe ainda está cadastrando as fotografias do acervo
// iconográfico, então o card fica escondido no site público até o
// cadastramento terminar. NÃO remova o card/lógica abaixo — só troque esta
// flag para `true` quando o acervo estiver pronto para publicação.
const ICONOGRAFIA_DISPONIVEL = false;

const VirtualCollectionSection = () => {
  return (
    <section className="virtual-collection-section" id="acervo">
      <div className="container">
        <h2 className="section-title-virtual-collection">Nossos Acervos</h2>
        <p className="section-subtitle">
          Conheça as coleções preservadas pelo Centro de Memória e Museu Histórico da FMRP-USP
        </p>
        
        <div className="collection-grid">
          {/* Card Acervo de Itens */}
          <Link to="/acervo" className="collection-card items-bg">
            <div className="card-content">
              <div className="card-header-info">
                <FontAwesomeIcon icon={faBoxArchive} className="card-icon" />
                <h3>Acervo de Equipamentos</h3>
              </div>
              <p>Explore instrumentos, mobiliários e objetos que marcaram a história da FMRP-USP desde sua fundação.</p>
            </div>
          </Link>

          {/* Card Acervo Iconográfico — escondido temporariamente (ver
              ICONOGRAFIA_DISPONIVEL no topo do arquivo), não removido. */}
          {ICONOGRAFIA_DISPONIVEL && (
            <Link to="/acervo-iconografico" className="collection-card iconographic-bg">
              <div className="card-content">
                <div className="card-header-info">
                  <FontAwesomeIcon icon={faCameraRetro} className="card-icon" />
                  <h3>Acervo Iconográfico</h3>
                </div>
                <p>Fotografias históricas que registram momentos marcantes da Faculdade de Medicina de Ribeirão Preto.</p>
              </div>
            </Link>
          )}
        </div>

      </div>
    </section>
  );
};

export default VirtualCollectionSection;